export const SET_LOADING_DATA = '@controlNotifications/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@controlNotifications/SET_LOADING_SELECTS';

export const GET_ALL_REQUEST = '@controlNotifications/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@controlNotifications/GET_ALL_SUCCESS';

export const GET_ALL_SELECTS_REQUEST = '@controlNotifications/GET_ALL_SELECTS_REQUEST';
export const GET_ALL_SELECTS_SUCCESS = '@controlNotifications/GET_ALL_SELECTS_SUCCESS';

export const SHARE_CSV = '@controlNotifications/SHARE_CSV';

export const SET_PAGE = '@controlNotifications/SET_PAGE';
export const SET_ROWS_COUNT = '@controlNotifications/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@controlNotifications/SET_ROWS_PER_PAGE';
export const SET_ROWS_ORIENTATION = '@controlNotifications/SET_ROWS_ORIENTATION';
export const SET_ORDER = '@controlNotifications/SET_ORDER';
export const SET_ORDERBY = '@controlNotifications/SET_ORDERBY';

export const SEARCH = '@controlNotifications/SEARCH';
